const Supply = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6260_12004)">
        <path
          d="M13.3333 4H2.66667C2.29848 4 2 4.29848 2 4.66667V13.3333C2 13.7015 2.29848 14 2.66667 14H13.3333C13.7015 14 14 13.7015 14 13.3333V4.66667C14 4.29848 13.7015 4 13.3333 4Z"
          stroke="#141516"
          strokeWidth="1.40351"
          strokeLinejoin="round"
        />
        <path
          d="M5.9834 8.00273H9.9834"
          stroke="#141516"
          strokeWidth="1.40351"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 4.33346L4.33333 1.66679H11.6667L14 4.33346"
          stroke="#141516"
          strokeWidth="1.40351"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6260_12004">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Supply;
